<ng-container>
  @if(api.userRole?.isCustomer && !api.isElectronApp && sessionService.isBlocked){
    <app-blocked-session></app-blocked-session>
  } @else {
    <div class="loader_page">
      <div id="offlineLoader" *ngIf="!api.isOnline">
        <fa-icon icon="wifi"></fa-icon>
        <span innerHTML="{{'internet.lost' | translate}}"></span>
      </div>
      <div class="main-container">
        <app-nav
          class="resp_minSize_l"
          *ngIf="(api.userRole?.isCustomer && api.userInfo) || (!api.userRole?.isCustomer && api.userInfo && api.userPlaceId)">
        </app-nav>
        <router-outlet #outlet="outlet"></router-outlet>
      </div>
    </div>
    <span
      *ngIf="!router.url?.startsWith('/showcase')"
      [matTooltip]="'tooltip.version' | translate"
      id="appVersion"
      (click)="electron?.dev()">
      {{api.env.name}} {{api.env.production ? 'PROD' : 'DEV'}} {{api.env.appVersion.join('.')}}
      <strong *ngIf="api.status">{{api.status | translate}}</strong>
    </span>
    <app-print-master></app-print-master>
    <app-devtool *ngIf="!api.env.production && api.env.devtool !== false"></app-devtool>
  }
  <app-cookie-consent></app-cookie-consent>
</ng-container>
